import ReactDOM from 'react-dom';

type Translate = (key: string, options?: Record<string, unknown>) => string;

export interface ShareForm {
  hours: number;
  maxViews: number;
}

interface ShareLinkModalProps {
  open: boolean;
  shareForm: ShareForm;
  shareLoading: boolean;
  t: Translate;
  onClose: () => void;
  onShareFormChange: React.Dispatch<React.SetStateAction<ShareForm>>;
  onGenerate: () => void;
}

export default function ShareLinkModal({
  open,
  shareForm,
  shareLoading,
  t,
  onClose,
  onShareFormChange,
  onGenerate,
}: ShareLinkModalProps) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div onClick={event => event.stopPropagation()} style={{ background: 'var(--surface)', borderRadius: 'var(--radius)', padding: '1.5rem', width: '320px', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
        <h3 style={{ margin: '0 0 1rem 0', fontSize: '1rem' }}>{t('shareModal.title')}</h3>
        <label style={{ display: 'block', marginBottom: '0.75rem', fontSize: '0.85rem' }}>
          {t('shareModal.hoursLabel')}
          <input
            type="number"
            min={1}
            max={720}
            value={shareForm.hours}
            onChange={event => onShareFormChange(form => ({ ...form, hours: parseInt(event.target.value) || 1 }))}
            style={{ display: 'block', width: '100%', marginTop: '0.3rem', padding: '0.4rem 0.5rem', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '0.85rem', boxSizing: 'border-box' }}
          />
        </label>
        <label style={{ display: 'block', marginBottom: '1rem', fontSize: '0.85rem' }}>
          {t('shareModal.maxViewsLabel')}
          <input
            type="number"
            min={0}
            max={9999}
            value={shareForm.maxViews}
            onChange={event => onShareFormChange(form => ({ ...form, maxViews: parseInt(event.target.value) || 0 }))}
            style={{ display: 'block', width: '100%', marginTop: '0.3rem', padding: '0.4rem 0.5rem', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '0.85rem', boxSizing: 'border-box' }}
          />
        </label>
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" style={{ fontSize: '0.8rem' }} onClick={onClose}>{t('cancel', { ns: 'common' })}</button>
          <button className="btn btn-primary" style={{ fontSize: '0.8rem' }} disabled={shareLoading} onClick={onGenerate}>
            {shareLoading ? t('shareModal.generating') : t('shareModal.generateAndCopy')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
